







































































import { computed, defineComponent, onUnmounted, ref, toRef, watch } from "@vue/composition-api";
import type { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useOrientation from "@/hooks/useOrientation";
import { connectionStateEnum } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import type { OlecamsLiveRoom } from "@/types/olecams";
import usePWPlayerCommunicator from "../../hooks/usePWPlayerCommunicator";
import StreamChat from "../StreamChat";

export default defineComponent({
  name: "StreamView",
  components: {
    BaseIconButton,
    BaseAvatar,
    BaseIcon,
    BaseButton,
    StreamChat,
  },
  props: {
    sessionToken: { type: String },
    videoFrameUrl: { type: String, required: true },
    chatFrameUrl: { type: String, required: true },
    loading: { type: Boolean, required: true },
    producer: { type: Object as () => UserPublicData },
    liveRoom: { type: Object as () => OlecamsLiveRoom },
    consumeUser: { type: Object as () => { id: string; username: string }, required: true },
  },
  setup(props, { emit }) {
    const { isLandscape } = useOrientation();

    const videoCommunicator = ref<ReturnType<typeof usePWPlayerCommunicator> | null>(null);

    const connectingState = computed(() => videoCommunicator.value?.state.connectingState);
    const connecting = computed(() =>
      videoCommunicator.value?.state.connecting || connectingState.value === connectionStateEnum.CONNECTING || props.loading);
    const isStreamAlive = computed(
      () => videoCommunicator.value?.state.connectingState === connectionStateEnum.CONNECTED
    );
    const showChat = computed(() => isStreamAlive.value && !props.loading);
    const isPrivate = computed(() => props.liveRoom?.roomMode === "private");
    const isVip = computed(() => props.liveRoom?.roomMode === "vip");
    const isOnline = computed(() => props.liveRoom?.status === "online");

    const reloadVideo = () => {
      emit("reload");
    };

    const initCommunicator = () => {
      if (!props.sessionToken) return;
      videoCommunicator.value = usePWPlayerCommunicator({
        sessionToken: props.sessionToken,
        onDisconnected: (reason: string) => {
          if (reason === "unknown") {
            reloadVideo();
          }
          if (reason === "offline") {
            emit("liveRoom:update", { online: 0, status: "offline" } as Partial<OlecamsLiveRoom>);
          }
          if (reason === "paid") {
            emit("liveRoom:update", { roomMode: "private" } as Partial<OlecamsLiveRoom>);
          }
        },
        onRoomModeUpdate: roomMode => {
          emit("liveRoom:update", { roomMode });
        },
      });
    };

    watch(toRef(props, "sessionToken"), initCommunicator);

    onUnmounted(() => {
      videoCommunicator.value?.cleanup();
    });

    return {
      isStreamAlive,
      isOnline,
      connecting,
      connectingState,
      showChat,
      isLandscape,
      connectionStateEnum,
      isPrivate,
      isVip,
      reloadVideo,
    };
  },
});
